import { useTranslation } from 'react-i18next';

import * as St from './EdgesHeader.styles';

import { useAppDispatch } from '~/redux/hooks';
import { updateApplySameEdge } from '~/redux/slices/edge';
import DesignSectionHeader from '~organisms/DesignSectionHeader';

type EdgesHeaderProps = {
  applySameEdge: boolean;
};

const EdgesHeader = ({ applySameEdge }: EdgesHeaderProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <DesignSectionHeader
      title={t('SCROLLABLE_AREA.EDGE.TITLE')}
      description={t('SCROLLABLE_AREA.EDGE.DESCRIPTION')}
    >
      <St.SameEdgeContainer>
        <St.SameEdgeText>
          {t('SCROLLABLE_AREA.EDGE.APPLY_SAME_EDGES')}
        </St.SameEdgeText>
        <St.Switch
          checked={applySameEdge}
          onChange={(checked) => dispatch(updateApplySameEdge(checked))}
        />
      </St.SameEdgeContainer>
    </DesignSectionHeader>
  );
};

export default EdgesHeader;
